/**
 * Shared constants for mobile overlay components.
 *
 * Used by: MobileDrawerNav, VoiceAgentFAB, GlobalAgentOverlay
 */

/** Distance from screen edge for FAB buttons (px) */
export const FAB_INSET = 16;

/** Floating action button diameter (px) */
export const FAB_SIZE = 56;

/** Panel margin from screen edge when expanded (px) */
export const PANEL_MARGIN = 12;

/**
 * Z-index scale for overlay layers.
 *
 *   fab-idle  (49) — below dialogs so burger/mic don't overlap fullscreen modals
 *   dialog    (50) — Radix Dialog / AlertDialog default
 *   backdrop  (55) — dark overlay behind expanded panels
 *   panel     (58) — expanded drawer / agent panel
 *   dropdown  (59) — dropdown-menu inside a panel (needs to sit above)
 *   fab-active(60) — close button on top of everything
 */
export const Z = {
  fabIdle: 49,
  dialog: 50,
  backdrop: 55,
  panel: 58,
  dropdown: 59,
  fabActive: 60,
} as const;

/** Spring config for panel expand animation (motion/react) */
export const EXPAND_SPRING = {
  type: "spring" as const,
  damping: 28,
  stiffness: 380,
};

/** Easing config for panel collapse animation */
export const COLLAPSE_TRANSITION = {
  duration: 0.2,
  ease: [0.4, 0, 1, 1] as const,
};

/** Content fade-in after panel expands */
export const CONTENT_FADE = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { delay: 0.1, duration: 0.2 } },
  exit: { opacity: 0, transition: { duration: 0.1 } },
};
